import { React, useEffect } from 'react';
import Header from '../components/Header';
import PartnerHeader from '../components/PartnerHeader';
import Sidebar from '../components/Sidebar';
import PartnerSidebar from '../components/PartnerSidebar';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const META = {
    partner: {
        title: 'LMTKOM - Vendor Dashboard',
        description: 'Manage your services, orders and pricing for your LMTKOM account.',
    },
    admin: {
        title: 'LMTKOM - Admin Dashboard',
        description: 'Manage users, partners, bookings and platform settings for LMTKOM.',
    },
};

const Layout = ({ children, hideHeader, hasPermission, layoutType = 'admin' }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!hasPermission) {
            toast.error("You don't have permission to access this!");
            navigate(-1);
        }
    }, [navigate]);

    useEffect(() => {
        const meta = META[layoutType] || META.admin;
        document.title = meta.title;
        let tag = document.querySelector('meta[name="description"]');
        if (!tag) {
            tag = document.createElement('meta');
            tag.name = 'description';
            document.head.appendChild(tag);
        }
        tag.content = meta.description;
    }, [layoutType]);

    return (
        <div className="d-flex flex-column flex-root app-root" id='kt_app_root'>
            <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
                {!hideHeader && (
                    <div>
                        {layoutType === 'partner' ? <PartnerHeader /> : <Header />}
                        <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
                            {layoutType === 'partner' ? <PartnerSidebar /> : <Sidebar />}
                            {children}
                        </div>
                    </div>
                )}
                {hideHeader && (
                    <main>
                        {children}
                    </main>
                )}
            </div>
        </div>
    );
};

export default Layout;
